import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'div'> & {
  children: string
}

export const PopoverListGroupTitle: FC<Props> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      className={clsx([
        'px-3 py-1 text-xs font-bold text-secondary',
        className
      ])}
    >
      {children}
    </div>
  )
}
